module.exports = __webpack_public_path__ + "static/media/psychometric_phone.12ef0476.jpg";